import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  MutationInput_LegalClientHeadController_SaveStatus_Input_Status,
  useLegalClientHeadSaveStatusMutation,
} from 'api/generated/graphql';
import { parseLegalClientHeadEntity, useError } from 'api/helpers';

interface Props {
  versionNumber: number;
  reason: string;
}

export const useLegalClientHeadArchive = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientHeadSaveStatusMutation();

  const error = useError(apolloError);

  return {
    legalClientHead: data?.saveStatus
      ? parseLegalClientHeadEntity(data.saveStatus)
      : undefined,
    loading,
    error,
    archive: useCallback(
      async (id: string, { reason, versionNumber }: Props) => {
        const res = await handle({
          variables: {
            id,
            input: {
              reason,
              versionNumber,
              status:
                MutationInput_LegalClientHeadController_SaveStatus_Input_Status.Archived,
            },
          },
        });
        return res.data?.saveStatus
          ? parseLegalClientHeadEntity(res.data?.saveStatus)
          : undefined;
      },
      [handle]
    ),
  };
};
